import React from 'react'

const Dialog = (props) => {
  return (
    <div style={{...styles.overlay, ...props.overlayStyle}}>
      <div style={{...styles.box, ...props.boxStyle}}>
        <div style={styles.title}>{props.title}</div>
        <div style={styles.content}>{props.content}</div>
        <div style={styles.buttons}>
          {props.buttons.map(button => (
            <button key={button.label} style={styles.button} onClick={button.onClick}>{button.label}</button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Dialog

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    backgroundColor: 'rgba(0,0,0,0.7)',
    zIndex: 100,
  },
  box: {
    width: '40vmin',
    backgroundColor: 'white',
    borderRadius: 5,
    padding: '2%',
    textAlign: 'center',
    margin: 'auto',
    color: 'black',
  },
  title: {
    textAlign: 'left',
    borderBottom: '2px solid grey',
    paddingBottom: '1vmin',
    margin: 0,
    fontWeight: 'bold',
    fontSize: '2vmin',
    textTransform: 'uppercase',
    wordWrap: 'break-word',
  },
  content: {
    padding: '2vmin 0',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1vmin',
  },
  button: {
    cursor: 'pointer',
    fontSize: '1.3vmin',
    padding: '.5vmin',
  }
}